export const handleSearchEnterKey = (event, onSearch) => {
  if (event.key !== "Enter") {
    return;
  }

  event.preventDefault();
  onSearch?.();
};

export const createSearchEnterHandler = (onSearch) => (event) =>
  handleSearchEnterKey(event, onSearch);
